import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import FindPollingStationDetails from './FindPollingStationDetails';
import FindPollingStationSuccess from './FindPollingStationSuccess';

const FindPollingStation = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(findPollingStation|findPollingStation/start)"
                            name="FindPollingStationDetails"
                            exact
                            component={FindPollingStationDetails}
                        />
                        <Route
                            path="/findPollingStation/success"
                            name="FindPollingStationSuccess"
                            exact
                            component={FindPollingStationSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default FindPollingStation;



// WEBPACK FOOTER //
// ./src/containers/FindPollingStation/FindPollingStation.jsx